import { createStore } from "vuex";
import axios from "axios";

const debug = process.env.NODE_ENV !== "production";

export const store = createStore({
  strict: debug,

  state: {
    reservations: [],
    provozniRadOpened: false,
  },

  getters: {
    reservations: (state) => state.reservations,
    pendingReservations: (state) =>
      state.reservations.filter((res) => res.status === "nepotvrzená"),
    confirmedReservations: (state) =>
      state.reservations.filter((res) => res.status === "potvrzená"),
    provozniRadOpened: (state) => state.provozniRadOpened,
  },

  actions: {
    getReservations({ commit }) {
      axios.get("/admin/reservations-extended").then((response) => {
        commit("SET_RESERVATIONS", response.data.data);
      });
    },

    removeReservation({ commit }, data) {
      axios.delete(`/admin/reservations/${data.id}`).then((res) => {
        if (res.status === 204) {
          commit("REMOVE_RESERVATION", data.id);
        }
      });
    },

    changeStatusTo({ commit }, { id, status }) {
      axios
        .post(`/admin/reservations/status/${id}/`, { status: status })
        .then(() => {
          commit("CHANGE_STATUS_TO", { status: status, id: id });
        });
    },
  },

  mutations: {
    SET_RESERVATIONS: (state, data) => (state.reservations = data),

    REMOVE_RESERVATION: (state, id) => {
      const index = state.reservations.findIndex((res) => res.id === id);
      state.reservations.splice(index, 1);
    },

    CHANGE_STATUS_TO: (state, { status, id }) => {
      const index = state.reservations.findIndex((res) => res.id === id);
      state.reservations[index].status = status;
    },

    OPEN_MODAL: (state) => {
      state.provozniRadOpened = true;
    },

    CLOSE_MODAL: (state) => {
      state.provozniRadOpened = false;
    },
  },
});
